<template>
  <div class="about g-content">
    <div class="u-title"><span class="u-title-txt">展会简介</span></div>
    <div class="about-info">
      <div class="ai-t">
        <img :src="exInfo.logo" />
        {{ exInfo.name }}
      </div>
      <div class="ai-b">
        {{ exInfo.remark }}
      </div>
    </div>
    <div class="u-title" v-if="exInfo.website"><span class="u-title-txt" >展会官网</span></div>
    <div class="about-brand" v-if="exInfo.website">
      <a :href="exInfo.website" target="_blank">{{ exInfo.website }}</a>
    </div>
    <div class="u-title" v-if="OrganList"><span class="u-title-txt" >组织架构</span></div>
    <div class="about-list" v-for="(item, index) in OrganList" :key="index">
      <div class="al-l">{{ item.title }}：</div>
      <div class="al-r">
        <span v-for="(cItem, index) in item.conList" :key="index">{{
          cItem
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "about",
  data() {
    return {
      OrganList: [], //组织架构
      exInfo: "",
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  created() {
    this.setShare();
    this.getExhibition();
    document.title = this.exhibitionInfo
      ? `关于-${this.exhibitionInfo.name}`
      : "仁创线上展";
  },
  methods: {
    ...mapActions({
      graphqlPost: "graphqlPostByZXS",
      getShareConfig:'share/getShareConfig',
    }),
    async setShare(){
      let data=await this.getShareConfig({id:this.exhibitionId,name:'share.exhibition.config'});
      let share = {
        url:location.href,
        title:'关于展会-'+this.exhibitionInfo.name,
        desc:'',
        summary:this.exhibitionInfo.remark,
        pics:this.exhibitionInfo.logo,
      };
      if(data){
        let dataJson=JSON.parse(data);
        if(dataJson.content){
          share.title=dataJson.content
        }
        if(dataJson.des){
          share.desc=dataJson.des;
          share.summary=dataJson.des;
        }
      }
      this.$store.commit('setShare',share);
    },
    async getExhibition() {
      let query = `
        query($id:String!){
          exhibitionQuery{
           get(id:$id){
                organization
                organizationEn
                remark
                logo
                name
                nameEn
                website
              }
          }
        }
      `;
      let opt = {
        query: query,
        variables: {
          id: this.exhibitionId,
        },
      };
      let res = await this.graphqlPost(opt);
      console.log(res, "----");
      if (res.data.exhibitionQuery.get) {
        this.exInfo = res.data.exhibitionQuery.get;
        if (this.exInfo.organization) {
          var organ = this.exInfo.organization;
          let arr = [];
          if (organ && organ.indexOf("[") != -1) {
            arr = JSON.parse(organ);
            console.log(arr, "arr");
            arr.forEach((e) => {
              e.conList = e.content.split("\n");
            });
          }
          this.OrganList = arr;
          console.log(this.OrganList, "1");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.about {
  margin-top: 20px;
  margin-bottom: 87px;
  background-color: #fff;
  border: solid 1px #ededed;
  padding: 12px 30px 70px;
  &-list {
    display: flex;
    margin-bottom: 38px;
    .al {
      &-l {
        width: 90px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
      &-r {
        flex: 1;
        font-size: 14px;
        color: #333;
        span {
          display: block;
        }
      }
    }
  }
  &-brand {
    background-color: #f7f7f7;
    border-radius: 3px;
    padding: 10px;
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    background-color: #f7f7f7;
  }
  &-info {
    .ai-t {
      img {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border: solid 1px #ededed;
        display: inline-block;
        margin-right: 15px;
      }
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #1a1a1a;
    }
    .ai-b {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
